import {
    brugereMenuLink,
    evalueringsstatistikMenuLink,
    forloebOverviewMenuLink,
    kursusBrugerUddannelseslaegeOverviewMenuLink,
    kursusoversigtMenu
} from "core/layout/shared/MenuLinkProps";
import { DynamicMenu } from "../DynamicMenu";
import MenuProps from "./menuProps";

export function KursusudbyderMenu({ showNotification, nyhederMenuLink }: MenuProps) {

    const menuLinks = [
        forloebOverviewMenuLink,
        kursusoversigtMenu,
        kursusBrugerUddannelseslaegeOverviewMenuLink,
        brugereMenuLink,
        evalueringsstatistikMenuLink,
        nyhederMenuLink,
        kursusoversigtMenu
    ];

    return (
        <DynamicMenu menuLinks={menuLinks} showNotifications={showNotification}/>
    );
}
